import $ from 'jquery';
import { View } from 'backbone';
import _template from 'properties/main/shared-settings-link.ejs';
import sharedSettingsView from 'common-views/SharedSettingsModalView.js';

class MainSharedSettingsLinkView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.events = {
            'click #sharedSettingsLink': 'viewSharedSettings'
        };

        return this;
    }

    viewSharedSettings(ev) {
        console.log('Show Shared Settings');

        var v = new sharedSettingsView({ model: this.model});
        v.render();
    }


    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));



        this.delegateEvents();
        return this;
    }


}

export default MainSharedSettingsLinkView;
